import { styled } from 'stitches.config'

export const Wrapper = styled('div', {
  margin: 'auto',
  backgroundColor: '$accent-white',
  px: '$3',

  '@bp2': {
    px: '$8',
  },
})

export const PostsListRoot = styled('div', {
  display: 'grid',
  gridGap: '$4',
  gridTemplateColumns: 'repeat(auto-fill, 377px)',
  placeContent: 'center',
})
